import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
import {currentResource} from '../../util/utils';
import Utility from '../../util/utilityfunctions';

export function accessGroupReducer(state = initialState.accessGroups, action) {
	switch (action.type) {
		case types.ADD_MEMBER:
		case types.UPDATE_MEMBER: {
			if (typeof action.response === 'string') {
				return [...state, {accessGroupId: action.response, ...action.payload.body}];
			} else {
				return state;
			}
		}
		case types.ADD_GROUP: {
			if (typeof action.response === 'string') {
				let newGroups = Utility.sortListData(
					[...state, {accessGroupId: action.response, ...action.payload}],
					'groupName'
				);
				return newGroups;
			} else return state;
		}
		case types.COPY_GROUP: {
			if (typeof action.response === 'string' && !action.response.errors) {
				var newGroups = state.filter((x) => x.accessGroupId !== action.oldGroupId);
				newGroups.push({accessGroupId: action.response, oldGroupId: action.oldGroupId, ...action.payload});
				return newGroups.sort((a, b) => a.groupName.localeCompare(b.groupName));
			} else {
				return state;
			}
		}

		case types.GET_ALL_GROUPS:
		case types.GET_PROJECT_GROUPS: {
			let accessGroups = action.response.filter((el) => el.isBuiltIn == false && el.isRemoved == false);
			return accessGroups;
		}
		case types.EDIT_GROUP_LOCAL: {
			var newGroups = state.filter((x) => x.accessGroupId !== action.groupId);
			newGroups.push({accessGroupId: action.groupId, ...action.payload, toBeEdited: true});
			return newGroups.sort((a, b) => a.groupName.localeCompare(b.groupName));
		}
		case types.DELETE_GROUP_LOCAL: {
			var deletedGroup = state.filter((x) => x.accessGroupId === action.groupId);
			var newGroups = state.filter((x) => x.accessGroupId !== action.groupId);
			newGroups.push({...deletedGroup[0], toBeDeleted: true});
			return newGroups.sort((a, b) => a.groupName.localeCompare(b.groupName));
		}
		case types.CLEAR_ALL_GROUPS: {
			return [];
		}
		default:
			return state;
	}
}

export function projectTeamReducer(state = initialState.projectTeam, action) {
	switch (action.type) {
		case types.GET_PROJECT_GROUPS: {
			return {
				...state,
				accessGroups: action.response
			};
		}
		case types.GET_PROJECT_ENTITIES: {
			return {
				...state,
				projectEntities: action.response
			};
		}
		default:
			return state;
	}
}
